import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import NavbarLeft from "../Components/NavbarLeft";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
// import PageDoc from "./components/rapport_analyse_html.html"
import AnalysisReport from "./components/AnalysisReport";
import { PDFViewer, BlobProvider } from "@react-pdf/renderer";
// import PDFViewer from "pdf-viewer-reactjs";

import { Worker, Viewer } from "@react-pdf-viewer/core";
// Plugins
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
// import { pdfjs } from "react-pdf";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { callAsync } from "tripetto-runner-foundation";

// Import styles
// import "@react-pdf-viewer/core/lib/styles/index.css";
import AnalysisProduceChoice from "../AnalysisPage/AnalysisProduceChoice";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import { calculImpactStepResult } from "../../utils/utils.js";
// import { generatePdfDoc } from "./components/renderToStem";
// Create new plugin instance

// PDF CORS ISSUE
// https://github.com/wojtekmaj/react-pdf/issues/36

import * as ReactDOMServer from "react-dom/server";
import { Page, Text, View, Document, Font, Image, StyleSheet, Svg } from "@react-pdf/renderer";

const ReportPage = () => {
  const location = useLocation();
  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual); //? state.analysis.optimization_data : null)
  const toolbarPluginInstance = toolbarPlugin();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const get_impact = (analysis_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor) => {
    let transports_impact;
    // let indicator_unit;
    if (step === 2) {
      //////////// get transport impact
      if (analysis_data.ingredients && !analysis_data.ingredients[flow_id].name) {
        const transports_data = Object.values(analysis_data.ingredients[flow_id]).find((x) => x.category.name === "K_Transports");
        if (transports_data) {
          const transports_data_inputs = Object.values(transports_data.inputs).filter((x) => x.flow.category.name === "K_Transports");
          transports_impact = Object.values(transports_data_inputs).reduce((accumulator, currentValue) => {
            const indicator = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id);
            const indicator_coefficient = indicator ? indicator.coefficient : 0;
            const amount = currentValue.amount;
            const conversion_factor = currentValue.unit.conversion_factor;
            return accumulator + indicator_coefficient * amount * conversion_factor;
          }, 0);
        }

        //////////// get ingredient impact
        if (Object.values(analysis_data.lca.lca_steps)[6 - step].inputs) {
          const ingredient = Object.values(Object.values(analysis_data.lca.lca_steps)[6 - step].inputs)[line_index];
          const ingredient_indicator = ingredient.flow.flow_impact_factors.find((i) => i.id === indicator_id);
          const ingredient_impact = ingredient_indicator ? ingredient.amount * ingredient.unit.conversion_factor * ingredient_indicator.coefficient : 0;
          transports_impact = transports_impact + ingredient_impact;
        }
      } else {
        transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
      }
    } else {
      // flow impact
      transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
    }
    return parseFloat(transports_impact);
  };

  const get_impact_optimization = (optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor) => {
    let transports_impact = 0;
    // let indicator_unit;
    if (step === 2) {
      //////////// get receip impact
      if (optimization_data.ingredients && !optimization_data.ingredients[flow_id].name) {
        // if ingredients

        // get transports categories
        const transports_data = Object.values(optimization_data.ingredients[flow_id]).find((x) => x.category.name === "K_Transports");
        // console.log("transports_data", transports_data);

        if (transports_data && transports_data.inputs) {
          // filter optimization
          const opt_inputs = Object.values(transports_data.inputs).filter((x) => x.optimization_results);
          // console.log("opt_inputs", opt_inputs);

          transports_impact =
            transports_impact +
            Object.values(opt_inputs).reduce((accumulator, currentValue) => {
              const indicator = currentValue.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator ? indicator.coefficient : 0;
              const amount = currentValue.optimization_results.amount;
              const conversion_factor = currentValue.optimization_results.unit.conversion_factor;
              return accumulator + indicator_coefficient * amount * conversion_factor;
            }, 0);

          // console.log('transports_impact', transports_impact)

          const nomal_inputs = Object.values(transports_data.inputs).filter((x) => !x.optimization_results);
          const transports_data_inputs = Object.values(nomal_inputs).filter((x) => x.flow.category.name === "K_Transports");
          transports_impact =
            transports_impact +
            Object.values(transports_data_inputs).reduce((accumulator, currentValue) => {
              const indicator = currentValue.flow.flow_impact_factors.find((i) => i.id === indicator_id);
              const indicator_coefficient = indicator ? indicator.coefficient : 0;
              const amount = currentValue.amount;
              const conversion_factor = currentValue.unit.conversion_factor;
              return accumulator + indicator_coefficient * amount * conversion_factor;
            }, 0);
        }

        // console.log('transports_impact', transports_impact)

        // //////////// get ingredient impact
        if (Object.values(optimization_data.lca.lca_steps)[6 - step].inputs) {
          const ingredient = Object.values(Object.values(optimization_data.lca.lca_steps)[6 - step].inputs)[line_index];
          const ingredient_indicator = ingredient.flow.flow_impact_factors.find((i) => i.id === indicator_id);
          const ingredient_impact = ingredient_indicator ? ingredient.amount * ingredient.unit.conversion_factor * ingredient_indicator.coefficient : 0;
          transports_impact = transports_impact + ingredient_impact;
        }

        // console.log('transports_impact', transports_impact)
      } else {
        transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
      }
    } else {
      transports_impact = impact_factors.find((i) => i.id === indicator_id).coefficient * quantity * conversion_factor;
    }

    return parseFloat(transports_impact).toFixed(2);
  };

  const get_report_formatted_step_results = (analysis_data) => {
    let results = [];
    Object.values(analysis_data.lca.lca_steps).map((x, i) => {
      let result = {};
      if (i === 0) {
        result["step_name"] = "Consommation";
      } else if (i === 1) {
        result["step_name"] = "Vente au détail";
      } else if (i === 2) {
        result["step_name"] = "Distribution";
      } else if (i === 3) {
        result["step_name"] = "Packaging";
      } else if (i === 4) {
        result["step_name"] = "Recette";
        console.log("iiii", x);
      }
      result["data"] = [];

      if (x.inputs) {
        Object.values(x.inputs).map((y, j) => {
          if (i === 4) {
            // flow_data

            const flow_id = y.id;
            const step = 6 - i;
            const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
            const line_index = j;
            const impact_factors = y.flow.flow_impact_factors;
            const conversion_factor = y.unit.conversion_factor;
            const quantity = y.amount;
            const score_unique = get_impact(analysis_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);

            // ingredients_data
            let res_origins = [];
            let res_transports = [];
            if (analysis_data.ingredients) {
              // Object.values(analysis_data.ingredients).map((x) => {
              const ingredient = analysis_data.ingredients[flow_id];
              // if is not ingredient
              if (ingredient.unit) {
                return;
              } else {
                // look for K_Raw_Materials
                Object.values(ingredient).map((w) => {
                  if (w.category.name === "K_Raw_Materials") {
                    // loop through inputs
                    Object.values(w.inputs).map((z) => {
                      let origin = {};
                      origin[z.origin] = parseFloat(z.amount * 100);
                      res_origins = [...res_origins, origin];
                    });
                  }
                });
              }
              // });
              Object.values(ingredient).map((w) => {
                if (w.category.name === "K_Transports") {
                  // loop through inputs
                  let transport_data = [];
                  if (w.inputs) {
                    Object.values(w.inputs).map((z) => {
                      // console.log('1. za: ', z)
                      // origin[z.origin] = parseFloat(z.amount * 100);
                      // res_origins = [...res_origins, origin];
                      if (z.flow.category.name === "K_Transports") {
                        let indicator_id_transport = "da32f256-618d-4bec-a8d9-205817788b26";
                        let impact_transport = parseFloat(z.flow.flow_impact_factors.find((i) => i.id === indicator_id_transport).coefficient);
                        // let impact = currentValue.flow.flow_impact_factors
                        let conversion_factor_transport = parseFloat(z.unit.conversion_factor);
                        let quantity_transport = parseFloat(z.amount);
                        let score_unique = impact_transport * quantity_transport * conversion_factor_transport;
                        res_transports.push({
                          flow_name: z.flow.name_fr,
                          k_type: z.flow.category.name,
                          quantity: z.amount,
                          unit: z.unit.name,
                          checked: y.checked, // herit from flow checked
                          score_unique: score_unique,
                          percent_impact: ((score_unique / analysis_data.unique_score) * 100).toFixed(2),
                          conversion_factor: z.unit.conversion_factor,
                        });
                      }
                      // console.log("2. transport_data", transport_data);
                      // const score_unique = get_impact(analysis_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
                    });
                  }
                  // res_transports.push(transport_data)
                }
              });
            }

            // store ingredient results
            result["data"].push({
              flow_name: y.flow.name_fr,
              k_type: y.flow.category.name,
              quantity: y.amount,
              unit: y.unit.name,
              checked: y.checked,
              score_unique: score_unique,
              percent_impact: ((score_unique / analysis_data.unique_score) * 100).toFixed(2),
              conversion_factor: y.unit.conversion_factor,
              origins: res_origins,
              transports: res_transports,
            });
          } else {
            // flow_data
            const flow_id = y.id;
            const step = 6 - i;
            const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
            const line_index = j;
            const impact_factors = y.flow.flow_impact_factors;
            const conversion_factor = y.unit.conversion_factor;
            const quantity = y.amount;
            const score_unique = get_impact(analysis_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
            result["data"].push({
              flow_name: y.flow.name_fr,
              k_type: y.flow.category.name,
              quantity: y.amount,
              unit: y.unit.name,
              checked: y.checked,
              score_unique: score_unique,
              percent_impact: ((score_unique / analysis_data.unique_score) * 100).toFixed(2),
              conversion_factor: y.unit.conversion_factor,
            });
          }
        });
      }

      if (x.outputs) {
        Object.values(x.outputs).map((y, j) => {
          if (y.flow.category.name === "K_Wastes" || y.flow.category.name === "K_Food_Given") {
            const flow_id = y.id;
            const step = 6 - i;
            const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
            const line_index = j;
            const impact_factors = y.flow.flow_impact_factors;
            const conversion_factor = y.unit.conversion_factor;
            const quantity = y.amount;
            const score_unique = get_impact(analysis_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
            result["data"].push({
              flow_name: y.flow.name_fr,
              k_type: y.flow.category.name,
              quantity: y.amount,
              unit: y.unit.name,
              checked: y.checked,
              score_unique: score_unique,
              percent_impact: ((score_unique / analysis_data.unique_score) * 100).toFixed(2),
              conversion_factor: y.unit.conversion_factor,
            });
          }
        });
      }

      // else {

      // }

      // const flow_id = x.outputs[0].flow.id;
      const step = 6 - i;
      const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
      // const line_index = null;
      // const impact_factors = x.outputs[0].flow.flow_impact_factors;
      // const conversion_factor = x.outputs[0].unit.conversion_factor;
      // const quantity = x.outputs[0].amount;
      const step_score = calculImpactStepResult(analysis_data, indicator_id, step);
      result["data"].push({
        flow_name: x.outputs[0].flow.name_fr,
        k_type: x.outputs[0].flow.category.name,
        quantity: x.outputs[0].amount,
        unit: x.outputs[0].unit.name,
        checked: x.outputs[0].checked,
        score_unique: step_score,
        percent_impact: ((step_score / analysis_data.unique_score) * 100).toFixed(2),
        conversion_factor: x.outputs[0].unit.conversion_factor,
      });

      results.push(result);
    });

    console.log("result", results);
    return results;
  };

  const get_report_formatted_step_results_optimization = (optimization_data) => {
    let results = [];
    Object.values(optimization_data.lca.lca_steps).map((x, i) => {
      let result = {};
      if (i === 0) {
        result["step_name"] = "Consommation";
      } else if (i === 1) {
        result["step_name"] = "Vente au détail";
      } else if (i === 2) {
        result["step_name"] = "Distribution";
      } else if (i === 3) {
        result["step_name"] = "Packaging";
      } else if (i === 4) {
        result["step_name"] = "Recette";
      }
      result["data"] = [];
      if (x.inputs) {
        Object.values(x.inputs).map((y, j) => {
          if (i === 4) {
            // flow_data
            const flow_id = y.id;
            const step = 6 - i;
            const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
            const line_index = j;
            const impact_factors = y.flow.flow_impact_factors;
            const conversion_factor = y.unit.conversion_factor;
            const quantity = y.amount;
            const score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);

            // ingredients_data
            let res_origins = [];
            let res_transports = [];
            if (optimization_data.ingredients) {
              // Object.values(analysis_data.ingredients).map((x) => {
              const ingredient = optimization_data.ingredients[flow_id];
              // if is not ingredient
              if (ingredient.unit) {
                return;
              } else {
                // look for K_Raw_Materials
                Object.values(ingredient).map((w) => {
                  if (w.category.name === "K_Raw_Materials") {
                    // loop through inputs
                    Object.values(w.inputs).map((z) => {
                      let origin = {};
                      origin[z.origin] = parseFloat(z.amount * 100);
                      res_origins = [...res_origins, origin];
                    });
                  }
                });
              }
              // });
              Object.values(ingredient).map((w) => {
                if (w.category.name === "K_Transports") {
                  // loop through inputs
                  let transport_data = [];
                  console.log("wwww", "inputs" in w);
                  if (w.inputs) {
                    Object.values(w.inputs).map((z) => {
                      // console.log('1. za: ', z)
                      // origin[z.origin] = parseFloat(z.amount * 100);
                      // res_origins = [...res_origins, origin];
                      if (z.optimization_results) {
                        // optimization_results
                        let res_transports_opt = {};
                        if (z.optimization_results.flow.category.name === "K_Transports") {
                          let indicator_id_transport = "da32f256-618d-4bec-a8d9-205817788b26";
                          let impact_transport = parseFloat(z.optimization_results.flow.flow_impact_factors.find((i) => i.id === indicator_id_transport).coefficient);
                          let conversion_factor_transport = parseFloat(z.optimization_results.unit.conversion_factor);
                          let quantity_transport = parseFloat(z.optimization_results.amount);
                          let score_unique = impact_transport * quantity_transport * conversion_factor_transport;
                          res_transports_opt["optimization_results"] = {
                            flow_name: z.optimization_results.flow.name_fr,
                            k_type: z.optimization_results.flow.category.name,
                            quantity: z.optimization_results.amount,
                            unit: z.optimization_results.unit.name,
                            checked: y.checked, // herit from flow checked
                            score_unique: score_unique,
                            percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                            conversion_factor: z.optimization_results.unit.conversion_factor,
                          };
                        }
                        // custom_analysis
                        if (z.custom_analysis.flow.category.name === "K_Transports") {
                          let indicator_id_transport = "da32f256-618d-4bec-a8d9-205817788b26";
                          let impact_transport = parseFloat(z.custom_analysis.flow.flow_impact_factors.find((i) => i.id === indicator_id_transport).coefficient);
                          let conversion_factor_transport = parseFloat(z.custom_analysis.unit.conversion_factor);
                          let quantity_transport = parseFloat(z.custom_analysis.amount);
                          let score_unique = impact_transport * quantity_transport * conversion_factor_transport;
                          res_transports_opt["custom_analysis"] = {
                            flow_name: z.custom_analysis.flow.name_fr,
                            k_type: z.custom_analysis.flow.category.name,
                            quantity: z.custom_analysis.amount,
                            unit: z.custom_analysis.unit.name,
                            checked: y.checked, // herit from flow checked
                            score_unique: score_unique,
                            percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                            conversion_factor: z.custom_analysis.unit.conversion_factor,
                          };
                        }
                        res_transports.push(res_transports_opt);
                      } else {
                        if (z.flow.category.name === "K_Transports") {
                          let indicator_id_transport = "da32f256-618d-4bec-a8d9-205817788b26";
                          let impact_transport = parseFloat(z.flow.flow_impact_factors.find((i) => i.id === indicator_id_transport).coefficient);
                          let conversion_factor_transport = parseFloat(z.unit.conversion_factor);
                          let quantity_transport = parseFloat(z.amount);
                          let score_unique = impact_transport * quantity_transport * conversion_factor_transport;
                          res_transports.push({
                            flow_name: z.flow.name_fr,
                            k_type: z.flow.category.name,
                            quantity: z.amount,
                            unit: z.unit.name,
                            checked: y.checked, // herit from flow checked
                            score_unique: score_unique,
                            percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                            conversion_factor: z.unit.conversion_factor,
                          });
                        }
                      }
                      // console.log("2. transport_data", transport_data);
                      // const score_unique = get_impact(analysis_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
                    });
                  }
                  // res_transports.push(transport_data)
                }
              });
            }

            // store ingredient results
            result["data"].push({
              flow_name: y.flow.name_fr,
              k_type: y.flow.category.name,
              quantity: y.amount,
              unit: y.unit.name,
              checked: y.checked,
              score_unique: score_unique,
              percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
              conversion_factor: y.unit.conversion_factor,
              origins: res_origins,
              transports: res_transports,
            });
          } else {
            if (y.optimization_results) {
              let res_opt = {};
              // flow_data opt
              let flow_id = y.optimization_results.id;
              let step = 6 - i;
              let indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
              let line_index = j;
              let impact_factors = y.optimization_results.flow.flow_impact_factors;
              let conversion_factor = y.optimization_results.unit.conversion_factor;
              let quantity = y.optimization_results.amount;
              let score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
              res_opt["optimization_results"] = {
                flow_name: y.optimization_results.flow.name_fr,
                k_type: y.optimization_results.flow.category.name,
                quantity: y.optimization_results.amount,
                unit: y.optimization_results.unit.name,
                checked: y.optimization_results.checked,
                score_unique: score_unique,
                percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                conversion_factor: y.optimization_results.unit.conversion_factor,
              };

              flow_id = y.custom_analysis.id;
              step = 6 - i;
              indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
              line_index = j;
              impact_factors = y.custom_analysis.flow.flow_impact_factors;
              conversion_factor = y.custom_analysis.unit.conversion_factor;
              quantity = y.custom_analysis.amount;
              score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
              res_opt["custom_analysis"] = {
                flow_name: y.custom_analysis.flow.name_fr,
                k_type: y.custom_analysis.flow.category.name,
                quantity: y.custom_analysis.amount,
                unit: y.custom_analysis.unit.name,
                checked: y.custom_analysis.checked,
                score_unique: score_unique,
                percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                conversion_factor: y.custom_analysis.unit.conversion_factor,
              };

              result["data"].push(res_opt);
            } else {
              // flow_data normal
              const flow_id = y.id;
              const step = 6 - i;
              const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
              const line_index = j;
              const impact_factors = y.flow.flow_impact_factors;
              const conversion_factor = y.unit.conversion_factor;
              const quantity = y.amount;
              const score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
              result["data"].push({
                flow_name: y.flow.name_fr,
                k_type: y.flow.category.name,
                quantity: y.amount,
                unit: y.unit.name,
                checked: y.checked,
                score_unique: score_unique,
                percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                conversion_factor: y.unit.conversion_factor,
              });
            }
          }
        });
      }

      if (x.outputs) {
        Object.values(x.outputs).map((y, j) => {
          if (y.flow.category.name === "K_Wastes" || y.flow.category.name === "K_Food_Given") {
            if (y.optimization_results) {
              let res_opt = {};
              // flow_data opt
              let flow_id = y.optimization_results.id;
              let step = 6 - i;
              let indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
              let line_index = j;
              let impact_factors = y.optimization_results.flow.flow_impact_factors;
              let conversion_factor = y.optimization_results.unit.conversion_factor;
              let quantity = y.optimization_results.amount;
              let score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
              res_opt["optimization_results"] = {
                flow_name: y.optimization_results.flow.name_fr,
                k_type: y.optimization_results.flow.category.name,
                quantity: y.optimization_results.amount,
                unit: y.optimization_results.unit.name,
                checked: y.optimization_results.checked,
                score_unique: score_unique,
                percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                conversion_factor: y.optimization_results.unit.conversion_factor,
              };

              flow_id = y.custom_analysis.id;
              step = 6 - i;
              indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
              line_index = j;
              impact_factors = y.custom_analysis.flow.flow_impact_factors;
              conversion_factor = y.custom_analysis.unit.conversion_factor;
              quantity = y.custom_analysis.amount;
              score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
              res_opt["custom_analysis"] = {
                flow_name: y.custom_analysis.flow.name_fr,
                k_type: y.custom_analysis.flow.category.name,
                quantity: y.custom_analysis.amount,
                unit: y.custom_analysis.unit.name,
                checked: y.custom_analysis.checked,
                score_unique: score_unique,
                percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                conversion_factor: y.custom_analysis.unit.conversion_factor,
              };

              result["data"].push(res_opt);
            } else {
              // flow_data normal
              const flow_id = y.id;
              const step = 6 - i;
              const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
              const line_index = j;
              const impact_factors = y.flow.flow_impact_factors;
              const conversion_factor = y.unit.conversion_factor;
              const quantity = y.amount;
              const score_unique = get_impact_optimization(optimization_data, indicator_id, flow_id, step, line_index, impact_factors, quantity, conversion_factor);
              result["data"].push({
                flow_name: y.flow.name_fr,
                k_type: y.flow.category.name,
                quantity: y.amount,
                unit: y.unit.name,
                checked: y.checked,
                score_unique: score_unique,
                percent_impact: ((score_unique / optimization_data.unique_score) * 100).toFixed(2),
                conversion_factor: y.unit.conversion_factor,
              });
            }
          }
        });
      }

      // else {

      // }

      // const flow_id = x.outputs[0].flow.id;
      const step = 6 - i;
      const indicator_id = "da32f256-618d-4bec-a8d9-205817788b26";
      // const line_index = null;
      // const impact_factors = x.outputs[0].flow.flow_impact_factors;
      // const conversion_factor = x.outputs[0].unit.conversion_factor;
      // const quantity = x.outputs[0].amount;
      const step_score = calculImpactStepResult(analysis_data, indicator_id, step);
      result["data"].push({
        flow_name: x.outputs[0].flow.name_fr,
        k_type: x.outputs[0].flow.category.name,
        quantity: x.outputs[0].amount,
        unit: x.outputs[0].unit.name,
        checked: x.outputs[0].checked,
        score_unique: step_score,
        percent_impact: ((step_score / analysis_data.unique_score) * 100).toFixed(2),
        conversion_factor: x.outputs[0].unit.conversion_factor,
      });

      results.push(result);
    });

    console.log("result", results);
    return results;
  };

  return (
    <>
      {analysis_data ? (
        <>
          <NavbarLeft currentPage={4} />
          <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
            <div className="w-full relative left-[70px] flex justify-start items-center">
              <Link to={location.state.from_nav ? location.state.from_nav : "/ReportChoice"}>
                <BackArrow />
              </Link>
              <div className="font-Poppins-SemiBold text-lg relative p-10">
                {"Communiquer - Rapport de l'analyse " +
                  '"' +
                  (location.state.type === "optimization" ? optimization_data.lca.lca_steps[0].ciqual_name.fr : analysis_data.lca.lca_steps[0].ciqual_name.fr) +
                  '"'}
              </div>
              {/* <p
                onClick={() => {
                  // const res = get_report_formatted_step_results(analysis_data);
                  // console.log("toto", get_report_formatted_step_results(analysis_data)[4].data);
                  // get_report_formatted_step_results(analysis_data)[4].data.map((x, i) => {
                  
                  // location.state.type, optimization_data)
                  // })
                  // get dict of result
                  // [{step_name: , data: }]
                }}
              >
                DEBUG
              </p> */}
            </div>
          </div>

          <ComponentLoading height={35} style={"h-full flex items-center justify-center absolute z-0"} />

          <div className="w-full h-[700px] px-[150px] bg-[red mt-[80px] flex justify-center z-10">
            {/* <p
              onClick={async () => {
                console.log("optimiza_data", get_report_formatted_step_results_optimization(optimization_data));
                // const pdfStream = await generatePdfDoc({ data: "Some String" });
                // const pdfBuffer = await streamToBuffer(pdfStream);
                // console.log("pdfStream", pdfStream);
                // console.log('pdfBuffer', pdfBuffer)
              }}
            >
              DEBUG
            </p> */}
            {/* <Worker workerUrl={"https://unpkg.com/pdfjs-dist@3.2.146/build/pdf.worker.min.js"}> */}
            {/* <PDFViewer
                showToolbar={true}
                style={{
                  backgroundColor: "white",
                  zoom: 0.5,
                  width: window.innerWidth / 1.2,
                  height: window.innerHeight / 1.2,
                }}
              >
                <AnalysisReport
                  eco_score={analysis_data.eco_score}
                  product_name={analysis_data.lca.lca_steps[0].ciqual_name.fr}
                  product_ref={analysis_id}
                  analysis_steps_results={location.state.type === "optimization" ? get_report_formatted_step_results_optimization(optimization_data) : get_report_formatted_step_results(analysis_data)}
                  is_optimization={location.state.type === "optimization"}
                  // analysis_id={analysis_data.lca.lca_steps[0].ciqual_name.fr}
                />
              </PDFViewer> */}

            {/* BlobProdiver https://codesandbox.io/s/nk6k26x2rj?file=/src/index.js:415-423 */}
            {/* custom iframe url https://tinytip.co/tips/html-pdf-params/ */}

            <BlobProvider
              document={
                <AnalysisReport
                  eco_score={location.state.type === "optimization" ? optimization_data.eco_score : analysis_data.eco_score}
                  product_name={location.state.type === "optimization" ? optimization_data.lca.lca_steps[0].ciqual_name.fr : analysis_data.lca.lca_steps[0].ciqual_name.fr}
                  product_ref={analysis_id}
                  analysis_steps_results={location.state.type === "optimization" ? get_report_formatted_step_results_optimization(optimization_data) : get_report_formatted_step_results(analysis_data)}
                  is_optimization={location.state.type === "optimization"}
                  // analysis_id={analysis_data.lca.lca_steps[0].ciqual_name.fr}
                />
              }
            >
              {({ url }) => <iframe src={url + "#zoom=67"} style={{ width: "100%", height: "100%" }} />}
            </BlobProvider>

            {/* </Worker> */}

            {/* IMPLEMNTATION OF BETTER DESIGN VIEWER: need pdf in url: possible when com-history */}
            {/* <Worker workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}> */}
            {/* <Worker workerUrl={"https://unpkg.com/pdfjs-dist@3.2.146/build/pdf.worker.min.js"}>
        //   <Viewer
        //     showToolbar={true}
        //     fileUrl="https://cors-anywhere.herokuapp.com/https://unec.edu.az/application/uploads/2014/12/p df-sample.pdf"
        //     plugins={[
        //       // toolbarPluginInstance,
        //       // Register plugins
        //       defaultLayoutPluginInstance,
        //     ]}
        //   />
        // </Worker> */}
          </div>
        </>
      ) : (
        <ComponentLoading height={35} style={"h-full flex items-center justify-center"} />
      )}
    </>
  );
};

// https://cors-anywhere.herokuapp.com/https://unec.edu.az/application/uploads/2014/12/pdf-sample.pdf

export default ReportPage;
